
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AdvancedSearch,
} from '../models';
import {
    AdvancedSearchFromJSON,
    AdvancedSearchToJSON,
} from '../models';

export interface GetAdvancedSearchRequest {
    advancedSearchId: string;
}

/**
 * 
 */
export class AdvancedSearchApi extends runtime.BaseAPI {

    /**
     * Retrieve advanced search
          */
    async getAdvancedSearchRaw(requestParameters: GetAdvancedSearchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdvancedSearch>> {
        if (requestParameters['advancedSearchId'] == null) {
            throw new runtime.RequiredError(
                'advancedSearchId',
                'Required parameter "advancedSearchId" was null or undefined when calling getAdvancedSearch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AdvancedSearch>({
            path: `/profile/api/advanced-search/{advancedSearchId}`.replace(`{${"advancedSearchId"}}`, encodeURIComponent(String(requestParameters['advancedSearchId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AdvancedSearchFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve advanced search
          */
    async getAdvancedSearch(requestParameters: GetAdvancedSearchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdvancedSearch> {
        const response = await this.getAdvancedSearchRaw(requestParameters, initOverrides);
        return response._data;
    }

}
